import React from 'react';
import { getData } from '../utils/Utils';
import * as DATA from '../utils/Data';
import Map from '../components/Map';

export default class MapContainer extends React.Component {
  constructor() {
    super();
    this.state = { mapGoogle: null, mapItems: false };
  }

  componentDidMount() {
    if (window.google) {
      this.setState({ mapGoogle: window.google });
    } else {
      const script = document.createElement('script');
      script.src =
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyAOOL3WnPnXA00i0rxmTsiZveV8WdnlQSA&callback=initMap';
      document.body.appendChild(script);
      window.initMap = () => {
        this.setState({ mapGoogle: window.google });
      };
    }

    getData(`${DATA.API_URL}/mapa/rows?status=1&limit=2000`, json => {
      this.setState({ mapItems: json.data });
    });
  }

  render() {
    return (
      <Map mapGoogle={this.state.mapGoogle} mapItems={this.state.mapItems} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/MapContainer.js